import React, { useEffect, useState } from "react";
import { BASE_CRM_URL } from "../../../components/config/config";
import dayjs from "dayjs";
import { Spin, Empty, message } from "antd";
import { useParams } from "react-router-dom";

const ProjectNotes = () => {
  const { id } = useParams();

  const [notes, setNotes] = useState([]);
  const [notesLoading, setNotesLoading] = useState(false);
  const [addNoteLoading, setAddNoteLoading] = useState(false);
  const [noteData, setNoteData] = useState({
    content: "",
    date_contacted: null,
  });
  const [editingNoteId, setEditingNoteId] = useState(null);
  const [editNoteData, setEditNoteData] = useState({
    content: "",
  });
  const [updateNoteLoading, setUpdateNoteLoading] = useState(false);

  const fetchNotes = async () => {
    try {
      setNotesLoading(true);

      const response = await fetch(
        `${BASE_CRM_URL}project/GetProjectNotes?id=${id}`,
      );

      const data = await response.json();

      if (data.Status) {
        setNotes(data.ResultData || []);
      } else {
        setNotes([]);
      }
    } catch (error) {
      console.error("Error fetching notes:", error);
      setNotes([]);
    } finally {
      setNotesLoading(false);
    }
  };
  useEffect(() => {
    fetchNotes();
  }, []);

  const handleEditNote = (note) => {
    setEditingNoteId(note.id);

    setEditNoteData({
      content: note.content,
    });
  };

  const handleCancelEdit = () => {
    setEditingNoteId(null);

    setEditNoteData({
      content: "",
    });
  };

  const handleAddNote = async () => {
    if (!noteData.content.trim()) {
      message.warning("Please enter a note.");
      return;
    }

    try {
      setAddNoteLoading(true);
      const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
      const userId = userDetails?.staffid;
      const response = await fetch(`${BASE_CRM_URL}project/AddProjectNotes`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          project_id: id,
          content: noteData.content,
          staff_id: userId,
        }),
      });

      const data = await response.json();

      if (data.Status) {
        message.success(data.Message);

        setNoteData({
          content: "",
          date_contacted: null,
        });

        fetchNotes();
      } else {
        message.error(data.Message);
      }
    } catch (error) {
      console.error(error);
      message.error("Something went wrong.");
    } finally {
      setAddNoteLoading(false);
    }
  };

  const handleUpdateNote = async () => {
    if (!editNoteData.content.trim()) {
      message.warning("Please enter a note.");
      return;
    }

    try {
      setUpdateNoteLoading(true);
      const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
      const userId = userDetails?.staffid;
      const response = await fetch(
        `${BASE_CRM_URL}project/UpdateProjectNotes`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: editingNoteId,
            content: editNoteData.content,
            staff_id: userId,
            project_id: id,
          }),
        },
      );

      const data = await response.json();

      if (data.Status) {
        message.success(data.Message);

        setEditingNoteId(null);

        setEditNoteData({
          content: "",
        });

        fetchNotes();
      } else {
        message.error(data.Message);
      }
    } catch (error) {
      console.error(error);
      message.error("Something went wrong.");
    } finally {
      setUpdateNoteLoading(false);
    }
  };

  const handelCancelNote = () => {
    setNoteData({
      content: "",
    });
  };

  return (
    <div>
      {" "}
      <div className="container mt-1">
        <div className="row">
          {notesLoading ? (
            <div className="text-center py-3">
              <Spin />
            </div>
          ) : (
            <>
              {/* Add Note Form */}
              {editingNoteId === null && (
                <>
                  <div className="row">
                    <div className="col-11">
                      <textarea
                        className="form-control"
                        rows="2"
                        placeholder="Enter your note here..."
                        value={noteData.content}
                        onChange={(e) =>
                          setNoteData((prev) => ({
                            ...prev,
                            content: e.target.value,
                          }))
                        }
                      />
                    </div>

                    <div className="col-1 mt-4">
                      {/* <button
                        className="btn btn-primary"
                        onClick={handleAddNote}
                        disabled={addNoteLoading}
                      >
                        {addNoteLoading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2"></span>
                            Adding...
                          </>
                        ) : (
                          "Add"
                        )}
                      </button> */}

                      <div className="d-flex align-items-center gap-2">
                        {/* Close Drawer */}
                        <button
                          type="button"
                          onClick={handelCancelNote}
                          className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                          style={{
                            width: "35px",
                            height: "35px",
                            backgroundColor: "#e40d22",
                            color: "#fff",
                            border: "none",
                          }}
                          title="Close"
                        >
                          <i className="fa fa-times" />
                        </button>

                        {/* Save */}
                        <button
                          type="button"
                          onClick={handleAddNote}
                          disabled={addNoteLoading}
                          className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                          style={{
                            width: "35px",
                            height: "35px",
                            backgroundColor: "#07f083",
                            color: "#fff",
                            border: "none",
                          }}
                          title="Save"
                        >
                          {addNoteLoading ? (
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                            />
                          ) : (
                            <i className="fa fa-check" />
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {/* Notes List or Empty */}
              {notes.length > 0 ? (
                <div className="mt-2">
                  {notes.map((note) => (
                    <div key={note.id} className="card border shadow-lg mb-3">
                      <div className="card-body">
                        {editingNoteId === note.id ? (
                          <>
                            <textarea
                              rows={2}
                              className="form-control mb-3"
                              value={editNoteData.content}
                              onChange={(e) =>
                                setEditNoteData({
                                  content: e.target.value,
                                })
                              }
                            />

                            <div className="d-flex justify-content-end gap-2">
                              {/* <button
                                className="btn btn-light"
                                onClick={handleCancelEdit}
                                disabled={updateNoteLoading}
                              >
                                Cancel
                              </button>

                              <button
                                className="btn btn-primary"
                                onClick={handleUpdateNote}
                                disabled={updateNoteLoading}
                              >
                                {updateNoteLoading ? (
                                  <>
                                    <span className="spinner-border spinner-border-sm me-2"></span>
                                    Updating...
                                  </>
                                ) : (
                                  "Update"
                                )}
                              </button> */}
                              <button
                                type="button"
                                onClick={handleCancelEdit}
                                disabled={updateNoteLoading}
                                className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                                style={{
                                  width: "35px",
                                  height: "35px",
                                  backgroundColor: "#e40d22",
                                  color: "#fff",
                                  border: "none",
                                }}
                                title="Close"
                              >
                                <i className="fa fa-times" />
                              </button>

                              {/* Save */}
                              <button
                                type="button"
                                onClick={handleUpdateNote}
                                disabled={updateNoteLoading}
                                className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                                style={{
                                  width: "35px",
                                  height: "35px",
                                  backgroundColor: "#07f083",
                                  color: "#fff",
                                  border: "none",
                                }}
                                title="Update"
                              >
                                {updateNoteLoading ? (
                                  <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                  />
                                ) : (
                                  <i className="fa fa-check" />
                                )}
                              </button>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="d-flex justify-content-between">
                              <p className="mb-2">{note.content}</p>
                              <button
                                className="btn btn-sm btn-outline-primary btn-icon"
                                onClick={() => handleEditNote(note)}
                              >
                                <i className="fa-solid fa-pen-to-square"></i>
                              </button>
                            </div>

                            <div className="d-flex justify-content-between align-items-center">
                              <div>
                                <small className="text-muted me-3">
                                  <i className="fa-regular fa-user me-2"></i>
                                  {note.StaffName}
                                </small>

                                <small className="text-muted">
                                  <i className="fa-regular fa-calendar me-2"></i>
                                  {dayjs(note.dateadded).format(
                                    "DD-MM-YYYY hh:mm A",
                                  )}
                                </small>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="col-12">
                  <Empty description="No notes found" />
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectNotes;
